<template>
  <span class="fill-height">
    <Loading :image="2" :loading="loading" />
    <div
      id="Drawing"
      class="Drawing"
      :class="loading ? 'fill-height' : 'simulator-container'"
    >
      <!-- <span v-if="!loading"> -->
      <NavbarDrawing v-if="!loading" />
      <!-- Telas largas: lista de objetos | área de desenho | propriedades (como no README).
           Celulares e tablets em pé: só o canvas; os painéis abrem pela barra inferior. -->
      <div class="sim-layout" :class="{ 'is-compact': compact }" v-if="!loading">
        <aside class="sim-col sim-col--left" v-if="!compact">
          <SideNavSimulator />
        </aside>
        <div class="sim-col sim-col--center">
          <div class="container-canvas">
            <v-stage
              :config="configKonva"
              :class="mode + ' ' + zoomAction"
              @wheel="ZOOM"
              @mousemove="MudarTamanhoDesenho"
              @mouseup="FimDesenho"
              @touchmove="MudarTamanhoDesenho"
              @touchend="FimDesenho"
              v-if="!showMiniCanvas"
            >
              <v-layer>
                <v-rect
                  :config="{
                    token: 'main',
                    width: dimensions.width,
                    height: dimensions.height,
                    fill: cell.fill,
                    id: 'mainRect'
                  }"
                  @mousedown="mouseDownEvent"
                  @touchstart="mouseDownEvent"
                />
                <v-rect
                  v-for="(item, indice) in (grid || [])"
                  :key="indice"
                  :config="{ ...item, visible: gridVisible }"
                  @mousedown="mouseDownEvent"
                  @touchstart="mouseDownEvent"
                  @dragmove="handleDrag"
                />
                <v-regular-polygon
                  v-for="geometry in (triangleGeometry || [])"
                  :key="geometry.token"
                  :config="{
                    ...geometry,
                    draggable:
                      currentGeometry.x + currentGeometry.width >=
                        dimensions.width || currentGeometry.x <= 0
                        ? false
                        : currentGeometry.y + currentGeometry.height >=
                            dimensions.height || currentGeometry.y <= 0
                        ? false
                        : mode === 'transform' && mode !== 'handle'
                        ? true
                        : false,
                    fill:
                      geometry.geometricFill.properties.image == ''
                        ? geometry.fill
                        : '',
                    fillPatternImage: geometry.geometricFill.properties.image,
                    fillPatternRepeat: 'repeat',
                    opacity: geometry.normalization === 'reference' ? 0.35 : 1,
                    dash: geometry.normalization === 'reference' ? [6, 4] : [],
                    stroke: geometry.normalization === 'reference' ? '#333' : geometry.stroke,
                    fillPatternScale: {
                      x:
                        (geometry.geometricFill.properties.width /
                          dimensions.relationship.x) *
                        1.5,
                      y:
                        (geometry.geometricFill.properties.height /
                          dimensions.relationship.y) *
                        1.5
                    }
                  }"
                  @transform="handleTransform"
                  @transformstart="handleTransformStart"
                  @dragmove="handleDrag"
                  @mousedown="mouseDownTransformEvent"
                  @touchstart="mouseDownTransformEvent"
                  @click="setSelectedTokenAction(geometry.token)"
                  @tap="setSelectedTokenAction(geometry.token)"
                />
                <v-circle
                  v-for="geometry in (circleGeometry || [])"
                  :key="geometry.token"
                  :config="{
                    ...geometry,
                    draggable:
                      currentGeometry.x + currentGeometry.width >=
                        dimensions.width || currentGeometry.x <= 0
                        ? false
                        : currentGeometry.y + currentGeometry.height >=
                            dimensions.height || currentGeometry.y <= 0
                        ? false
                        : mode === 'transform' && mode !== 'handle'
                        ? true
                        : false,
                    fill:
                      geometry.geometricFill.properties.image == ''
                        ? geometry.fill
                        : '',
                    fillPatternImage: geometry.geometricFill.properties.image,
                    fillPatternRepeat: 'repeat',
                    opacity: geometry.normalization === 'reference' ? 0.35 : 1,
                    dash: geometry.normalization === 'reference' ? [6, 4] : [],
                    stroke: geometry.normalization === 'reference' ? '#333' : geometry.stroke,
                    fillPatternScale: {
                      x:
                        (geometry.geometricFill.properties.width /
                          dimensions.relationship.x) *
                        1.5,
                      y:
                        (geometry.geometricFill.properties.height /
                          dimensions.relationship.y) *
                        1.5
                    }
                  }"
                  @transform="handleTransform"
                  @transformstart="handleTransformStart"
                  @dragmove="handleDrag"
                  @mousedown="mouseDownTransformEvent"
                  @touchstart="mouseDownTransformEvent"
                  @click="setSelectedTokenAction(geometry.token)"
                  @tap="setSelectedTokenAction(geometry.token)"
                />
                <v-rect
                  v-for="geometry in (blockGeometry || [])"
                  :key="geometry.token"
                  @transform="handleTransform"
                  @transformstart="handleTransformStart"
                  @dragmove="handleDrag"
                  @mousedown="mouseDownTransformEvent"
                  @touchstart="mouseDownTransformEvent"
                  @click="setSelectedTokenAction(geometry.token)"
                  @tap="setSelectedTokenAction(geometry.token)"
                  :config="{
                    ...geometry,
                    draggable:
                      currentGeometry.x + currentGeometry.width >=
                        dimensions.width || currentGeometry.x <= 0
                        ? false
                        : currentGeometry.y + currentGeometry.height >=
                            dimensions.height || currentGeometry.y <= 0
                        ? false
                        : mode === 'transform' && mode !== 'handle'
                        ? true
                        : false,
                    fill:
                      geometry.geometricFill.properties.image == ''
                        ? geometry.fill
                        : '',
                    fillPatternImage: geometry.geometricFill.properties.image,
                    fillPatternRepeat: 'repeat',
                    opacity: geometry.normalization === 'reference' ? 0.35 : 1,
                    dash: geometry.normalization === 'reference' ? [6, 4] : [],
                    stroke: geometry.normalization === 'reference' ? '#333' : geometry.stroke,
                    fillPatternScale: {
                      x:
                        (geometry.geometricFill.properties.width /
                          dimensions.relationship.x) *
                        1.5,
                      y:
                        (geometry.geometricFill.properties.height /
                          dimensions.relationship.y) *
                        1.5
                    }
                  }"
                />
                <!-- Extensão física das fontes (linha) e direção do feixe gaussiano -->
                <v-line
                  v-for="shape in sourceDecorations"
                  :key="shape.key"
                  :config="shape"
                />
                <v-circle
                  v-for="source in (SourcesList || [])"
                  :key="source.token"
                  :config="{
                    token: source.token,
                    class: 'source',
                    x: source.x,
                    y: source.y,
                    radius: 7,
                    fill: source.fill || '#FF0000',
                    stroke: source.token === selectedToken ? '#000' : '#fff',
                    strokeWidth: 2,
                    draggable: mode === 'transform',
                    dragBoundFunc: boundToCell
                  }"
                  @dragmove="handleDrag"
                  @mousedown="mouseDownTransformEvent"
                  @touchstart="mouseDownTransformEvent"
                  @click="setSelectedTokenAction(source.token)"
                  @tap="setSelectedTokenAction(source.token)"
                />
                <!-- Monitores: linha (transmissão/reflexão) ou ponto (ressonância) -->
                <component
                  :is="monitor.component"
                  v-for="monitor in monitorShapes"
                  :key="monitor.config.token"
                  :config="monitor.config"
                  @dragmove="handleDrag"
                  @mousedown="mouseDownTransformEvent"
                  @touchstart="mouseDownTransformEvent"
                  @click="setSelectedTokenAction(monitor.config.token)"
                  @tap="setSelectedTokenAction(monitor.config.token)"
                />
                <v-transformer id="transformer" ref="transformer" />
              </v-layer>
            </v-stage>
          </div>
        </div>
        <aside class="sim-col sim-col--right" v-if="!compact">
          <RightNavSimulator />
        </aside>
      </div>
      <SimulatorCompactPanels v-if="!loading && compact" @fit="fitCellToScreen">
        <template #left><SideNavSimulator /></template>
        <template #right><RightNavSimulator /></template>
      </SimulatorCompactPanels>
      <LoadingModal />
      <BenchmarkDialog />
      <PreviewSimulationModal />
    </div>
  </span>
</template>
<script>
import methods from "./js/methods";
import computed from "./js/computed";
import api from "@/services/api";
import Loading from "@/components/Loading";
import Swal from "sweetalert2";

export default {
  name: "Simulator",
  components: {
    Loading,
    NavbarDrawing: () => import("@/components/Navbar"),
    SideNavSimulator: () => import("@/components/SideNavSimulator"),
    RightNavSimulator: () => import("@/components/RightNavSimulator"),
    LoadingModal: () => import("@/components/LoadingModal"),
    BenchmarkDialog: () => import("@/components/BenchmarkDialog"),
    PreviewSimulationModal: () => import("@/components/PreviewSimulationModal"),
    SimulatorCompactPanels: () => import("@/components/SimulatorCompactPanels")
  },
  data() {
    return {
      loading: true,
      currentStart: {},
      circleGeometry: [],
      triangleGeometry: [],
      blockGeometry: [],
      grid: []
    };
  },
  computed: {
    ...computed,
    // Monitores em pixels do canvas (o comprimento é guardado em µm)
    monitorShapes() {
      const colors = { transmission: "#1565c0", reflection: "#ef6c00", resonance: "#6a1b9a" };
      return (this.FluxList || []).map(monitor => {
        const selected = monitor.token === this.selectedToken;
        const color = colors[monitor.kind] || "#1565c0";
        const base = {
          token: monitor.token,
          class: "flux",
          x: monitor.x,
          y: monitor.y,
          draggable: this.mode === "transform",
          dragBoundFunc: this.boundToCell
        };
        if (monitor.kind === "resonance") {
          return {
            component: "v-circle",
            config: { ...base, radius: 6, fill: "#fff", stroke: color, strokeWidth: selected ? 4 : 3 }
          };
        }
        const half = (Math.abs(Number(monitor.length) || 0) * this.dimensions.relationship.x) / 2;
        const points = monitor.orientation === "horizontal" ? [-half, 0, half, 0] : [0, -half, 0, half];
        return {
          component: "v-line",
          config: {
            ...base,
            points,
            stroke: color,
            strokeWidth: selected ? 5 : 3,
            hitStrokeWidth: 14,
            dash: monitor.kind === "reflection" ? [8, 4] : []
          }
        };
      });
    },
    sourceDecorations() {
      const shapes = [];
      const relation = this.dimensions.relationship;
      (this.SourcesList || []).forEach(source => {
        const [sx, sy] = (source.waveSize || [0, 0]).map(v => Math.abs(Number(v) || 0));
        if (sx > 0 || sy > 0) {
          shapes.push({
            key: source.token + "-size",
            x: source.x, y: source.y,
            points: [-sx * relation.x / 2, -sy * relation.y / 2, sx * relation.x / 2, sy * relation.y / 2],
            stroke: "#ff5252", strokeWidth: 3, opacity: 0.8, listening: false
          });
        }
        if (source.sourceType === "gaussian_beam") {
          // Seta de 1,5 µm no sentido de propagação (ângulo medido a partir de +x, anti-horário)
          const angle = ((Number(source.beamAngle) || 0) * Math.PI) / 180;
          const length = 1.5 * relation.x;
          const tipX = Math.cos(angle) * length;
          const tipY = -Math.sin(angle) * length;
          const head = 0.35 * relation.x;
          shapes.push({
            key: source.token + "-dir",
            x: source.x, y: source.y,
            points: [0, 0, tipX, tipY,
              tipX - head * Math.cos(angle - 0.5), tipY + head * Math.sin(angle - 0.5),
              tipX, tipY,
              tipX - head * Math.cos(angle + 0.5), tipY + head * Math.sin(angle + 0.5)],
            stroke: "#ff5252", strokeWidth: 2, listening: false
          });
        }
      });
      return shapes;
    },
    // Abaixo de 960 px (celulares e tablets em pé) as barras laterais viram painéis da barra inferior
    compact() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  watch: {
    loading(isLoading) {
      if (!isLoading) this.$nextTick(this.fitCellToScreen);
    },
    compact() {
      this.$nextTick(this.fitCellToScreen);
    },
    selectedToken: function() {
      if (this.mode == "transform") {
        this.updateTransformer();
      }
    },
    viewMode: function() {
      this.updateTransformer();
    },
    mode: function() {
      this.updateTransformer();
    },
    GeometryList: function() {
      if (!this.GeometryList) return;
      this.circleGeometry = this.GeometryList.filter(
        val => val.shape == "sphere"
      );
      this.blockGeometry = this.GeometryList.filter(
        val => val.shape == "block"
      );
      this.triangleGeometry = this.GeometryList.filter(
        val => val.shape == "triangle"
      );
      this.updateState();
    }
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.keyPressAction);
    document.removeEventListener("keyup", this.keySolveAction);
    document.removeEventListener("mouseup", this.FimDesenho);
    document.removeEventListener("touchend", this.FimDesenho);
    window.removeEventListener("resize", this.onResize);
  },
  created: async function() {},
  mounted: async function() {
    this.init();
  },
  methods: {
    ...methods,
    setPageInfo: function() {
      document.title = "Simulator - ElectrosFI";
      document
        .querySelector('meta[name="description"')
        ?.setAttribute(
          "content",
          "Simulate and edit photonic tools online - ElectrosFI"
        );
    },
    blockReload: function() {
      window.onbeforeunload = function() {
        return "";
      };
    },
    init: async function() {
      await api
        .get(this.$route.params.key)
        .then(response => {
          try {
            this.setState(response);
          } catch (err) {
            Swal.fire({
              title: "An error appears in your simulation!",
              text: err.message
            });
          }
        })
        .then(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });

      document.addEventListener("keydown", this.keyPressAction);
      document.addEventListener("keyup", this.keySolveAction);
      // encerra o desenho mesmo se o mouse for solto fora do canvas
      document.addEventListener("mouseup", this.FimDesenho);
      document.addEventListener("touchend", this.FimDesenho);
      window.addEventListener("resize", this.onResize);
      
      this.setKonvaStageAction(
        this.$refs.transformer
          ? this.$refs.transformer.getNode().getStage()
          : ""
      );

      this.setPageInfo();
    },
    onResize: function() {
      this.$store.commit("simulator/setStageSize", {
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.fitCellToScreen();
    },
    // No celular/tablet, escala e centraliza a célula para caber na área visível
    fitCellToScreen: function() {
      if (!this.compact || !this.$refs.transformer) return;
      const stage = this.$refs.transformer.getNode().getStage();
      const canvasRect = stage.container().getBoundingClientRect();
      const appBarHeight = 48;
      const bottomBarHeight = 56;
      const padding = 12;
      // Painel de propriedades fixo abaixo do canvas (tela em pé)
      const dockedPanel = document.querySelector(".sim-sheet--docked");
      const dockedHeight = dockedPanel ? dockedPanel.offsetHeight : 0;
      const availableWidth = window.innerWidth - padding * 2;
      const availableHeight =
        window.innerHeight -
        appBarHeight -
        bottomBarHeight -
        dockedHeight -
        padding * 2;
      const scale = Number(
        Math.min(
          1,
          availableWidth / this.dimensions.width,
          availableHeight / this.dimensions.height
        ).toFixed(2)
      );
      stage.scale({ x: scale, y: scale });
      stage.position({
        x: (window.innerWidth - this.dimensions.width * scale) / 2 - canvasRect.left,
        y:
          appBarHeight +
          padding +
          (availableHeight - this.dimensions.height * scale) / 2 -
          canvasRect.top
      });
      stage.batchDraw();
      this.$store.commit("simulator/setCurrentScale", scale);
    },
    geometryFrom: function() {
      var listaDeTodasAsGeometrias = [];
      return listaDeTodasAsGeometrias;
    },
    geometryInsideVerify: function() {
      return [];
    },
    constructGrid() {
      for (var x = 0; x < 600; x += 600 / 60) {
        for (var y = 0; y < 600; y += 600 / 60) {
          this.grid.push({
            x,
            y,
            width: 600 / 60,
            height: 600 / 60,
            stroke: "grey",
            strokeWidth: 0.01
          });
        }
      }
    }
  }
};
</script>
<style lang="scss">
@import "./styles.scss";
</style>
